import { NodeSortAction } from "@iventis/domain-model/model/nodeSortAction";
import { TreeBrowserQueryString } from "@iventis/tree-browser";
import { userLocalStorageItems, userLocalStorageManager } from "@iventis/local-storage/src/user-local-storage";
import { getLibrarySorts } from "./library-sorting";

export const getExpandedNodeId = () => {
    const queryParameters = new URLSearchParams(window.location.search);
    const queryParametersExpandedNodeId = queryParameters.get(TreeBrowserQueryString.EXPANDED_NODE_ID);
    return queryParametersExpandedNodeId != null ? [queryParametersExpandedNodeId] : [];
};

export const getSort = (userId: string) => {
    const storageSort = userLocalStorageManager.get(userLocalStorageItems.folderBrowserSort, userId) || { field: "name", action: NodeSortAction.FolderFirstAsc };
    return getLibrarySorts().find((sort) => sort.action === storageSort.action);
};

export const getMainNodeId = (libraryId: string) => {
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.get(TreeBrowserQueryString.MAIN_NODE_ID) ?? libraryId;
};
